/* GG_FLUID_BENEFITS_34: viewport-sized repeats and an exact one-group animation period. */
(() => {
  if (window.ggBenefitsMarquee34) return;
  window.ggBenefitsMarquee34 = true;
  const ribbons = new Map();
  const desktop = window.matchMedia('(min-width: 990px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let tapeObserver;
  let observedTape;
  let refreshFrame;

  function syncTapeHeight() {
    const tapes = Array.from(document.querySelectorAll('.ggm-tape.gg03-tape, .ggm-tape'));
    const tape = tapes.find(item => item.getClientRects().length && getComputedStyle(item).display !== 'none');
    const height = tape ? parseFloat(getComputedStyle(tape).height) : 0;
    if (height > 0) document.documentElement.style.setProperty('--gg34-ribbon-height', `${height}px`);
    else document.documentElement.style.removeProperty('--gg34-ribbon-height');
    if (tape !== observedTape) {
      tapeObserver?.disconnect();
      observedTape = tape;
      if (tape && 'ResizeObserver' in window) {
        tapeObserver ||= new ResizeObserver(queueRefresh);
        tapeObserver.observe(tape);
      }
    }
  }

  function outerWidth(element) {
    // A rotated boundingClientRect includes the parent's angle. Use layout width instead.
    const style = getComputedStyle(element);
    let width = parseFloat(style.width);
    if (style.boxSizing !== 'border-box') {
      for (const name of ['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth']) width += parseFloat(style[name]) || 0;
    }
    return width > 0 ? width : element.offsetWidth;
  }

  class Ribbon {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('.ggm-marquee-track');
      this.source = this.track?.querySelector('.ggm-marquee-list:not([aria-hidden])') || this.track?.querySelector('.ggm-marquee-list');
      if (!this.track || !this.source || !this.source.children.length) return;
      this.baseSeconds = Number(element.dataset.gg34Duration) || parseFloat(getComputedStyle(this.track).animationDuration) || 40;
      this.baseSeconds = Math.max(1, this.baseSeconds);
      this.landing = element.dataset.gg34Landing === 'true';
      // Preserve one original list, including Shopify editor attributes. Replace its old duplicate.
      Array.from(this.track.children).forEach(child => { if (child !== this.source) child.remove(); });
      this.clones = [];
      this.period = 0;
      this.duration = 0;
      element.classList.add('gg34-marquee');
      this.valid = true;
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.queue());
        this.resizeObserver.observe(element);
        this.resizeObserver.observe(this.source);
      }
      this.refresh();
    }
    queue() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); });
    }
    duplicate() {
      const copy = this.source.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      copy.removeAttribute('id');
      copy.removeAttribute('data-shopify-editor-block');
      copy.removeAttribute('data-shopify-editor-section');
      copy.querySelectorAll('[id], [data-shopify-editor-block], [data-shopify-editor-section]').forEach(node => {
        node.removeAttribute('id'); node.removeAttribute('data-shopify-editor-block'); node.removeAttribute('data-shopify-editor-section');
      });
      copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
      this.track.append(copy);
      this.clones.push(copy);
    }
    refresh() {
      if (!this.valid || !this.element.isConnected) return;
      const noMotion = reduced.matches || typeof this.track.animate !== 'function';
      this.element.classList.toggle('gg34-reduced', noMotion);
      if (noMotion) {
        this.animation?.cancel(); this.animation = null;
        this.clones.forEach(node => node.remove()); this.clones = [];
        return;
      }
      const period = outerWidth(this.source);
      if (!(period > 0)) return;
      const viewport = this.element.clientWidth || window.innerWidth + 160;
      // Even at the end of a cycle, at least one full extra group remains beyond the right edge.
      const total = Math.ceil(viewport / period) + 2;
      while (this.clones.length < total - 1) this.duplicate();
      while (this.clones.length > total - 1) this.clones.pop().remove();
      const duration = this.baseSeconds * (this.landing && desktop.matches ? 2 / 3 : 1) * 1000;
      if (this.animation && Math.abs(period - this.period) < .01 && duration === this.duration) return;
      const previousTime = Number(this.animation?.currentTime) || 0;
      const offset = this.duration ? (previousTime % this.duration) / this.duration * this.period : 0;
      this.animation?.cancel();
      this.period = period;
      this.duration = duration;
      this.animation = this.track.animate([
        { transform: 'translate3d(0, 0, 0)' },
        { transform: `translate3d(${-period}px, 0, 0)` }
      ], { duration, iterations: Infinity, easing: 'linear', fill: 'both' });
      // Resizing or loading a font keeps the current travel distance instead of snapping to zero.
      this.animation.currentTime = (offset % period) / period * duration;
      this.visibility();
    }
    visibility() {
      if (!this.animation) return;
      if (document.hidden) this.animation.pause();
      else this.animation.play();
    }
    destroy() {
      this.animation?.cancel(); this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  }

  function refreshAll() {
    refreshFrame = null;
    syncTapeHeight();
    ribbons.forEach((instance, element) => {
      if (!element.isConnected) { instance.destroy(); ribbons.delete(element); }
      else instance.refresh();
    });
  }
  function queueRefresh() {
    if (!refreshFrame) refreshFrame = requestAnimationFrame(refreshAll);
  }
  function initialize() {
    syncTapeHeight();
    document.querySelectorAll('.ggm-marquee').forEach(element => {
      if (ribbons.has(element) || element.closest('.ggm-static-benefits')) return;
      const instance = new Ribbon(element);
      if (instance.valid) ribbons.set(element, instance);
    });
  }
  function start() {
    initialize();
    document.fonts?.ready.then(queueRefresh);
    document.fonts?.addEventListener?.('loadingdone', queueRefresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('resize', queueRefresh, { passive: true });
  desktop.addEventListener('change', queueRefresh);
  reduced.addEventListener('change', queueRefresh);
  document.addEventListener('visibilitychange', () => ribbons.forEach(instance => instance.visibility()));
  document.addEventListener('shopify:section:load', () => { initialize(); queueRefresh(); });
  document.addEventListener('shopify:section:unload', event => {
    ribbons.forEach((instance, element) => { if (event.target.contains(element)) { instance.destroy(); ribbons.delete(element); } });
  });
})();
